module.exports = __webpack_public_path__ + "images/category_lp/watch/rolex_samples/pattern_d3/btn_4_pc_5c8ef1a04dca1fbc2f972899e7d1e0fd.png";